import { render } from "./App.vue?vue&type=template&id=98734d08"
const script = {}

import "./App.vue?vue&type=style&index=0&id=98734d08&lang=scss"

import exportComponent from "C:\\laragon\\www\\ve\\portal\\ve-vue-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__